var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.53999 19.5196C4.92999 19.5196 4.35999 19.3096 3.94999 18.9196C3.42999 18.4296 3.17999 17.6896 3.26999 16.8896L3.63999 13.6496C3.70999 13.0396 4.07999 12.2296 4.50999 11.7896L12.72 3.09956C14.77 0.929561 16.91 0.869561 19.08 2.91956C21.25 4.96956 21.31 7.10956 19.26 9.27956L11.05 17.9696C10.63 18.4196 9.84999 18.8396 9.23999 18.9396L6.01999 19.4896C5.95895 19.4932 5.9005 19.498 5.84324 19.5028C5.74099 19.5113 5.64254 19.5196 5.53999 19.5196ZM15.93 2.90956C15.16 2.90956 14.49 3.38956 13.81 4.10956L12.7132 5.27179C13.1857 7.40554 14.9018 9.04391 17.0548 9.40934L18.16 8.23956C19.4 6.91956 19.85 5.69956 18.04 3.99956C17.24 3.22956 16.55 2.90956 15.93 2.90956ZM5.59999 12.8096L11.5187 6.53764C12.2581 8.50679 13.8657 10.0287 15.8708 10.6625L9.94999 16.9296C9.74999 17.1396 9.26999 17.3996 8.97999 17.4496L5.75999 17.9996C5.42999 18.0496 5.15999 17.9896 4.97999 17.8196C4.79999 17.6496 4.71999 17.3796 4.75999 17.0496L5.12999 13.8096C5.16999 13.5196 5.39999 13.0196 5.59999 12.8096Z",
    fill: "#1B75BC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 22.7495H21C21.41 22.7495 21.75 22.4095 21.75 21.9995C21.75 21.5895 21.41 21.2495 21 21.2495H3C2.59 21.2495 2.25 21.5895 2.25 21.9995C2.25 22.4095 2.59 22.7495 3 22.7495Z",
    fill: "#1B75BC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.76221a7ec620a3b36cf6fedfd0327923.svg";
export { ForwardRef as ReactComponent };